export default "__VITE_ASSET__CZOw96$U__"